module.exports = __webpack_public_path__ + "static/media/stickers.8c28b454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameShipPainting/stickers.png
// module id = 2472
// module chunks = 0